import axios from "axios";
import {createUrlParams} from "../../utils/urlParams";


export const getIncidents = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/public/incidents?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}

export const getIncidentTotals = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/public/incidents/totals?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}

export const getIncident = async (id) => {
    const url = `/api/v1/public/incidents/${id}`;

    const res = await axios.get(url);
    return res.data;
}

export const getIncidentAttachments = async (incidentId) => {
    const url = `/api/v1/public/incidents/${incidentId}/attachments`;

    const res = await axios.get(url);
    return res.data;
}
